const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-banner">
        <h1 className="text-3xl md:text-6xl">SWIFTSKATE</h1>
        <p>
          Zapewniamy klientom wysokiej jakości, innowacyjne produkty do jazdy na łyżwach i rolkach, które inspirują do aktywnego trybu życia i radości z ruchu na świeżym powietrzu.
        </p>
        <a href="#tours" className="btn hero-btn">
          SPRAWDŹ PRODUKTY
        </a>
      </div>
    </section>
  );
};
export default Hero;
